import { useUserProfile } from "../../user/use-user-profile";

export function useIsProfileMissingEmail() {
  const { data: profile } = useUserProfile();
  return !(profile?.emailAddresses && profile.emailAddresses.length > 0);
}
